import React from 'react'
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Fullscreen from '@mui/icons-material/Fullscreen';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import GridViewIcon from '@mui/icons-material/GridView';
import IImage from './IImage';

interface Props {
    images: IImage[];
    currentImage: number;
    setFullscreenMode: () => void;
    setGridMode: () => void;
    onNextImage: () => void;
    onBeforeImage: () => void;
};

const navigateIconsStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    padding: '5px',
    '&:hover': {
        bgcolor: 'primary.light'
    }
}

const PortfolioModalImageSingle: React.FunctionComponent<Props> = ({ images, currentImage, setFullscreenMode, onNextImage, onBeforeImage, setGridMode }) => {

    const { apiUrl } = window.appConfig;

    return (
        <>
            <Box sx={{
                position: 'relative',
                height: '100%',
            }}>
                <Box component="img" aria-label='current-image'
                    sx={{
                        height: '100%',
                        maxWidth: '100%',
                        objectFit: 'cover'
                    }}
                    src={`${apiUrl}/file/${images[currentImage].reference}`}
                >
                </Box>

                <Box sx={{
                    position: 'absolute',
                    top: '13px',
                    left: '13px',
                }}>
                    <IconButton
                        onClick={() => { setGridMode(true) }}
                        aria-label="grid-open"
                    >
                        <GridViewIcon
                            sx={{
                                color: '#ffffff',
                                height: '24px',
                                width: '24px',
                                '&:hover': {
                                    color: 'primary.light'
                                }
                            }}
                        />
                    </IconButton>

                    <IconButton
                        onClick={() => { setFullscreenMode(true) }}
                        aria-label="fullscreen-open"
                    >
                        <Fullscreen
                            sx={{
                                color: '#ffffff',
                                height: '30px',
                                width: '30px',
                                '&:hover': {
                                    color: 'primary.light'
                                }
                            }}
                        />
                    </IconButton>

                </Box>

            </Box>

            <IconButton
                onClick={onBeforeImage}
                aria-label="before-image"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: 15,
                }}
            >
                <NavigateBefore
                    sx={navigateIconsStyle} />
            </IconButton>

            <IconButton
                onClick={onNextImage}
                aria-label="next-image"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    right: 15,
                }}
            >
                <NavigateNext
                    sx={navigateIconsStyle} />
            </IconButton>
        </>
    )
}

export default PortfolioModalImageSingle